<template>
  <div class="page" >
    <div class="head" >《隐私协议》</div>
    <div class="main">
      隐私协议 <br />
      欢迎您使用
      [呼和浩特专业技术人员继续教育在线学习网]。我们深知隐私对您的重要性，致力于保护您的个人信息安全。本隐私协议旨在向您说明，当您使用本网站时，我们如何收集、使用、共享、存储和保护您的个人信息。
      请您在使用本网站前，仔细阅读并理解本隐私协议的内容。<br />
      一、定义个人信息：<br />
      指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。在本隐私协议中，包括但不限于您的姓名、联系方式、地址、身份证号码、浏览记录、交易记录等。
      敏感个人信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。在本隐私协议中，敏感个人信息包括但不限于身份证号码、金融账户信息、健康信息等。
      Cookie：是指一种技术，当您访问本网站时，我们的服务器会向您的浏览器发送一个小型数据文件。Cookie
      通常包含标识符、站点名称以及一些号码和字符，可用于识别您的浏览器，帮助我们了解您的浏览习惯，优化网站服务。
      去标识化：指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别特定自然人的过程。
      匿名化：指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。 <br />
      二、我们如何收集您的个人信息
      我们收集您的个人信息主要是为了向您提供更好的服务，提升用户体验，并保障网站的安全和正常运行。我们收集信息的方式包括：
      您主动提供的信息：当您注册账户、订阅邮件、发表评论、参与问卷调查或使用需要填写个人信息的功能时，我们会收集您填写的信息。例如，注册时您可能需要提供姓名、电子邮箱地址、密码等；订阅邮件时，我们会收集您的邮箱地址；发表评论时，您的用户名和评论内容会被收集。
      自动收集的信息：当您访问本网站时，我们的服务器会自动记录一些信息，包括但不限于您的 IP
      地址、浏览器类型、操作系统、访问时间、浏览页面记录等。这些信息有助于我们了解网站的使用情况，优化网站性能和用户体验。此外，我们还可能使用
      Cookie 及类似技术来收集信息。Cookie
      可以帮助我们识别您的设备，记住您的偏好和设置，以便为您提供更个性化的服务。您可以通过浏览器设置选择拒绝
      Cookie，但这可能会影响您对本网站某些功能的使用体验。
      从第三方获取的信息：在某些情况下，我们可能从合法的第三方合作伙伴处获取您的个人信息，前提是这些第三方已获得您的合法授权。例如，我们可能从社交媒体平台获取您授权共享的公开信息，以便您能够通过社交媒体账号快速登录本网站。
      <br />
      三、我们如何使用您的个人信息
      提供服务：我们使用您的个人信息来为您提供本网站的各项服务，包括但不限于账户管理、内容展示、订单处理、客户支持等。例如，使用您的注册信息为您提供个性化的服务界面，根据您的浏览历史为您推荐可能感兴趣的内容。
      改进服务：我们会分析收集到的个人信息，以了解用户的使用习惯和需求，从而改进网站的功能和服务，提升用户体验。例如，通过分析用户的浏览行为，优化网站的页面布局和导航。
      安全保障：我们使用个人信息来保障本网站的安全，预防和应对网络攻击、欺诈等安全风险。例如，通过分析 IP
      地址等信息，识别异常的访问行为，采取相应的安全措施。
      营销推广：在您同意的情况下，我们可能使用您的个人信息向您发送有关本网站的产品、服务、优惠活动等营销信息。您可以随时通过退订或其他提供的方式拒绝接收此类信息。
      法律合规：我们可能会根据法律法规的要求，使用您的个人信息以遵守法律义务，例如响应法院传票、政府调查等。<br />
      四、我们如何共享、转让和公开披露您的个人信息 共享：我们不会将您的个人信息共享给其他公司、组织和个人，除非以下情况： 获得您的明确同意。
      与我们的关联公司共享，但我们会要求关联公司遵守本隐私协议，对您的个人信息进行保护。
      与服务提供商共享，这些服务提供商为我们提供技术支持、数据处理、客户服务等服务，且仅在履行其职责所必需的范围内使用您的个人信息，并受保密协议约束。
      在法律法规允许的范围内，为解决争议、维护社会公共利益或保护我们及其他用户的合法权益，与相关机构或第三方共享。
      转让：我们不会将您的个人信息转让给其他公司、组织或个人，除非获得您的明确同意，或在涉及合并、收购、破产清算等交易时，在确保个人信息安全的前提下，将相关个人信息作为交易的一部分进行转让，并要求新的持有方继续遵守本隐私协议。
      公开披露：我们不会公开披露您的个人信息，除非获得您的明确同意，或根据法律法规的要求、司法机关或行政机关的强制要求进行公开披露。<br />
      五、我们如何存储和保护您的个人信息
      存储：我们将在中华人民共和国境内存储您的个人信息。存储期限根据法律法规的要求以及为实现本隐私协议所述目的所必需的最短时间确定。在超出存储期限后，我们将对您的个人信息进行删除或匿名化处理。
      保护：我们采取合理的技术和组织措施，保护您的个人信息免受未经授权的访问、使用、修改、披露或破坏。这些措施包括但不限于数据加密、访问控制、定期安全审计等。然而，请注意，尽管我们努力保护您的个人信息，但由于技术的限制和可能存在的恶意攻击，网络安全并不能得到绝对保障。因此，我们建议您采取适当的措施保护自己的个人信息安全，例如设置强密码、不随意透露个人信息等。
      <br />
      六、您的权利 访问权：您有权随时访问您在本网站的个人信息，包括查看、编辑您的账户信息等。您可以通过登录账户，在相关设置页面进行操作。
      更正权：如果您发现我们收集、存储的您的个人信息存在错误或不准确，您有权要求我们进行更正。您可以通过联系我们的客服人员，提供相关证明材料，我们将及时核实并进行更正。
      删除权：在符合法律法规规定的情况下，您有权要求我们删除您的个人信息。例如，当我们处理您的个人信息的行为违反法律法规，或您撤回同意且我们没有其他合法依据继续处理时，您可以向我们提出删除请求。我们将在收到请求后的合理时间内进行处理，并告知您处理结果。
      撤回同意权：对于需要您同意才能进行的个人信息处理活动，您有权随时撤回同意。撤回同意不影响撤回前基于您的同意已进行的个人信息处理活动的合法性。您可以通过账户设置或联系我们的客服人员进行撤回操作。
      投诉权：如果您对我们处理您个人信息的行为有任何疑问、意见或投诉，您可以通过本隐私协议提供的联系方式与我们联系。我们将在收到您的反馈后的合理时间内进行处理，并回复您的问题。如果您对我们的处理结果不满意，您还可以向相关监管部门进行投诉。
      <br />
      七、未成年人的个人信息保护
      本网站不面向未成年人提供服务。如果我们发现我们收集了未成年人的个人信息，我们将尽快删除相关信息。如果您是未成年人的监护人，发现未成年人向我们提供了个人信息，请您及时联系我们，我们将采取必要措施保护未成年人的个人信息安全。
      <br />
      八、隐私协议的变更
      我们可能会根据法律法规的变化、业务发展或其他原因，对本隐私协议进行修订。修订后的隐私协议将在本网站上公布，公布日期即为修订生效日期。如果修订后的隐私协议对您的权利产生重大影响，我们将通过适当的方式通知您，例如在网站首页显著位置提示或向您注册的电子邮箱发送通知。在修订后的隐私协议生效后，您继续使用本网站，即表示您同意接受修订后的隐私协议的约束。
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},

  data() {
    // 这里存放数据
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.scrollTo(0, 0);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
.page {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.head {
  margin-top: 40px;
  text-align: center;
}
.main {
  margin-top: 40px;
  width: 1200px;
  height: 1626px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #111010;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
</style>
